<template>
  <div>
    <div class="store">
      <div class="banxin">
        <div style="background: #fff">
          <div class="dingbu">
            <div class="toutou warp">
              <div style="height: 79px">
                <img
                  src="../../assets/images/dlogo.png"
                  alt=""
                  class="logo"
                  @click="gotoIndex"
                />
              </div>
              <div
                style="
                  width: 2px;
                  height: 40px;
                  background-color: #eeeff1;
                  margin: 10px 20px;
                  margin-top: 38px;
                "
              ></div>

              <div class="menu">
                <div
                  class="menu-flag"
                  @mouseout="showClassify = false"
                  @mouseover="
                    $route.name !== 'index' ? (showClassify = true) : null
                  "
                >
                  <div style="z-index: 1000">
                    <span>商品分类</span>
                  </div>
                  <span
                    class="el-icon-arrow-right"
                    style="margin-left: 4px; margin-top: 2px"
                    :class="`${showClassify ? 'turnDown' : 'turnDown2'}`"
                  ></span>
                  <div
                    v-show="showClassify"
                    class="classify-outer"
                    :class="`${showClassify ? 'showClassify' : ''}`"
                    style="
                      background-color: #fff;
                      z-index: 999;
                      margin-top: -12px;
                    "
                  >
                    <cere-classification
                      style="height: auto !important"
                      :componentContent="componentContent[0].componentContent"
                    ></cere-classification>
                  </div>
                </div>
                <!-- {{componentContent[0]}} -->
                <!-- <ul>
              <li
                v-for="(item, index) in componentContent[0].labelList"
                :key="index"
              >
                <a
                  :class="{ active: isActive(item.name) }"
                  @click="jumpLink(item.linkObj)"
                  >{{ item.name }}</a
                >
              </li>
            </ul> -->
              </div>
              <div class="searchright">
                <div style="display: flex; justify-content: right">
                  <el-input
                    class="shuru"
                    placeholder="请输入内容"
                    prefix-icon="el-icon-search"
                    v-model="searchFrom.search"
                  >
                  </el-input>
                  <!-- <div class="serachBtn"> -->
                  <div class="quanzhan">
                    <el-button
                      type="primary"
                      class="qzBtn"
                      @click="getAllProduct"
                      >搜全站
                    </el-button>
                  </div>
                </div>

                <div class="bendain">
                  <el-button type="info" class="bdBtn" @click="getInfoProduct"
                    >搜本店</el-button
                  >
                </div>
                <!-- </div> -->
              </div>
            </div>
            <div class="shop">
              <div
                class="warp"
                style="
                  display: flex;
                  justify-content: space-between;
                  padding: 30px 0 5px;
                  position: relative;
                "
              >
                <div class="shop1">
                  <!-- <div class="shopLogo">
              <img v-if="shopLogo" :src="shopLogo" alt="" />
              <img v-else src="../../assets/images/logo.png" alt="" />
            </div> -->
                  <div class="shopInfo-box">
                    <div class="shopHeard">
                      <div>
                        <h2 class="shopName">{{ shopName }}</h2>
                      </div>

                      <div
                        class="guanzhu"
                        @click.stop="collect"
                        :style="
                          collectData.ifCollect === 0
                            ? ''
                            : 'background-color: rgba(255, 71, 71, 1);color: #fff;'
                        "
                      >
                        {{ collectData.ifCollect === 0 ? "关注" : "已关注" }}
                      </div>
                      <div
                        class="shopCode"
                        style="
                          margin-left: 20px;
                          cursor: pointer;
                          position: relative;
                        "
                      >
                        <img
                          style="width: 30px; margin-top: 8px"
                          src="@/assets/images/shopCode.png"
                          alt=""
                          @mouseout="shopCode = false"
                          @mouseover="shopCode = true"
                        />
                        <div
                          v-if="shopCode == true"
                          style="
                            position: absolute;
                            top: 0px;
                            left: 50px;
                            z-index: 1000;
                            background: #ffffff;
                            width: 250px;
                            height: 250px;
                            text-align: center;
                            padding: 10px;
                            box-shadow: 0px 5px 10px 0px
                              rgba(231, 234, 235, 0.93);
                            border-radius: 4px;
                          "
                        >
                          <vue-qr
                            
                            :size="200"
                            :margin="0"
                            :auto-color="true"
                            :dot-scale="1"
                            :text="appSrc"
                          />
                          <div
                            style="
                              width: 100%;
                              text-align: center;
                              margin-top: 5px;
                            "
                          >
                            店铺二维码（手机APP扫码）
                          </div>
                        </div>
                      </div>
                      <!-- <div class="erweima">
                  <img
                    class="weixin"
                    src="../../assets/images/dainzhuwechat.png"
                    alt=""
                  />
                </div> -->
                    </div>

                    <div class="information">
                      <img
                        class="renzheng"
                        src="../../assets/images/renzheng.png"
                        alt=""
                      />
                      <!-- <img
                        class="qiye"
                        src="../../assets/images/qiye.png"
                        alt=""
                      />
                      <span class="qiyeAge">一年</span> -->
                      <span class="dizhi">
                        <i
                          class="icon-positioning"
                          style="
                            color: #fb7600;
                            font-size: 20px;
                            margin-right: 5px;
                          "
                        ></i>
                        {{ this.adressForm.shopAdress }}</span
                      >
                      <!-- <span class="chanpin">主营产品：<nbsp />{{ shopName }}</span> -->

                      <!-- <div class="infomokuai" v-show="showShopInfo">
                  <div>
                    <el-card class="box-card" style="width: 400px">
                      <div slot="header" class="clearfix">
                        <div class="a">
                          <span
                            style="
                              font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                              font-weight: bold;
                              font-size: 26px;
                              color: #333333;
                              line-height: 26px;
                            "
                            >{{ this.adressForm.shopAdress }}</span
                          >
                        </div>
                        <div class="b">
                          <img
                            style="width: 19px; height: 24px; padding-top: 2px"
                            src="../../assets/images/qiye.png"
                            alt=""
                          />
                        </div>
                        <div class="c"><span>一年</span></div>
                      </div>
                      <div class="qiyerenzheng">
                        <div class="d">
                          <span class="font-size:19px">法人代表：李四</span>
                          <span class="font-size:19px">商品数量：90</span>
                        </div>
                        <div class="d">
                          <span class="font-size:19px"
                            >成立时间：2021-9-21</span
                          >
                          <span class="font-size:19px"
                            >等级机关：隆阳区市场监督管理局</span
                          >
                        </div>
                      </div>
                    </el-card>
                  </div>
                </div> -->
                    </div>
                    <!-- <span
                >信誉
                <img
                  v-for="i in 5"
                  :key="i"
                  src="../../assets/images/diamond.png"
                  alt=""
                  srcset=""
              /></span> -->
                  </div>
                </div>
                <!-- <div class="shopInfo" v-if="this.$route.name === 'store'">
              <div class="favoritesBox cur-poi" @click="collect">
                <img
                  style="width: 18px; height: 18px"
                  v-if="collectData.ifCollect === 0"
                  src="../../../static/image/sc0.png"
                  alt=""
                />
                <img
                  style="width: 18px; height: 18px"
                  v-else
                  src="../../../static/image/sc1.png" 
                  alt=""
                />
                <div class="text">收藏店铺</div>
              </div>
            </div> -->
                <!-- <span class="word63"></span> -->
                <div
                  style="
                    width: 550px;
                    font-size: 24px;
                    font-weight: bold;
                    color: #864c17;
                    position: absolute;
                    top: 50px;
                    left: 45%;
                  "
                >
                  严选优质商品&emsp; 直供源价好货
                </div>
                <div style="margin-right: 50px; text-align: right">
                  <div class="block11">
                    <img
                      class="img1"
                      referrerpolicy="no-referrer"
                      src="../../assets/images/tel.png"
                    />
                    <div
                      style="
                        margin-top: 5px;
                        margin-left: 10px;
                        font-size: 18px;
                      "
                    >
                      <span class="info34">店铺服务热线:</span>
                      <span>{{ formData.chargePersonPhone }}</span>
                    </div>
                  </div>
                  <!-- <div
              class="block12"
              @mouseover="showShopWechat = true"
              @mouseout="showShopWechat = false"
            >
              <img
                class="bd26 flex-col"
                src="../../assets/images/erweima.png"
                alt=""
              />
              <span class="info35">店主微信</span>
              <div class="erweimamokuai" v-show="showShopWechat">
                <el-card
                  style="width: 250px; height: 249px; text-align: center"
                >
                  <div>
                    <img
                      style="width: 182px; height: 187px; margin: 0 auto"
                      src="../../assets/images/erweima.png"
                      alt=""
                      srcset=""
                    />
                    <div>
                      <span style="width: 100%; font-size: 14px"
                        >扫一扫二维码添加店主微信</span
                      >
                    </div>
                  </div>
                </el-card>
              </div>
            </div> -->
                </div>
              </div>
            </div>
            <div class="el-tab-box">
              <el-tabs
                class="tabs warp"
                v-model="activeName"
                @tab-click="handleClick"
              >
                <el-tab-pane label="首页" name="index"></el-tab-pane>
                <!-- <el-tab-pane label="所有商品" name="all"></el-tab-pane> -->
                <el-tab-pane
                  style="position: relative"
                  label="产品分类"
                  name="shopClassifyList"
                >
                  <div
                    style="display: inline-block; height: 100%"
                    slot="label"
                    @mouseover="showMenu = true"
                    @mouseleave="showMenu = false"
                  >
                    <div
                      style="
                        width: 150px;
                        height: 100%;
                        margin-left: -15px;
                        padding: 0 -20px;
                      "
                      @click.stop="getClassifyProduct('')"
                    >
                      产品分类
                      <i
                        :class="
                          showMenu
                            ? 'el-icon-caret-bottom selectMenu'
                            : 'el-icon-caret-bottom'
                        "
                      ></i>
                    </div>

                    <div v-if="showMenu" slot="label" class="ShopMenu">
                      <div class="menuall">
                        <div style="border-right: 1px solid #e5e5e5">
                          <div
                            class="menuItem"
                            v-for="(item, index) in shopClassifyList"
                            :key="index"
                            @mouseover="getChildren(item)"
                            @mouseleave="clianChildren"
                            @click.stop="getClassifyProduct(item.classifyId)"
                          >
                            <span>{{ item.classifyName }}</span>
                            <i
                              style="margin-left: 10px"
                              :class="
                                showMenu2
                                  ? 'el-icon-arrow-right selectMenu2'
                                  : 'el-icon-arrow-right'
                              "
                            ></i>
                          </div>
                        </div>

                        <div style="background-color: #fff; color: #000">
                          <div class="hoverBox">
                            <div
                              class="dl"
                              v-for="(subItem, index) in menuChildren.childs"
                              :key="index"
                            >
                              <div class="dt" style="cursor: pointer">
                                <span
                                  @click.stop="
                                    getClassifyProduct(subItem.classifyId)
                                  "
                                  >{{ subItem.classifyName }}</span
                                >
                              </div>
                              <div class="dd">
                                <a
                                  class="a-link"
                                  v-for="(threeItem, index) in subItem.childs"
                                  :key="index"
                                >
                                  <span
                                    @click.stop="
                                      getClassifyProduct(threeItem.classifyId)
                                    "
                                    >{{ threeItem.classifyName }}</span
                                  >
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <!-- <i class="el-icon-arrow-down cur-poi el-icon--right"></i> -->
                <el-tab-pane label="公司档案" name="dossier"></el-tab-pane>
                <el-tab-pane label="联系我们" name="contact"></el-tab-pane>
                <!-- <el-tab-pane :label="item.classifyName" v-for="item in shopClassifyList" :key="item.classifyId" :name="item.classifyId.toString()" ></el-tab-pane> -->
              </el-tabs>
            </div>
          </div>
        </div>
        <div class="warp">
          <div v-if="isIndex">
            <shopHome
              v-if="shopId"
              :terminal="4"
              :typeId="3"
              :shopId="shopId"
            ></shopHome>
          </div>
          <div v-else-if="isShopClassifyList">
            <!-- <img v-if="banner" class="banner" :src="banner" alt=""> -->
            <div class="content">
              <el-breadcrumb
                separator-class="el-icon-arrow-right"
                style="font-size: 16px"
              >
                <el-breadcrumb-item
                  v-for="(items, index) in breadList"
                  :key="index"
                  ><span
                    class="bread"
                    @click="getClassifyProduct(items.classifyId)"
                    >{{ items.classifyName }}</span
                  ></el-breadcrumb-item
                >
              </el-breadcrumb>
              <div
                style="
                  background: #ffffff;
                  margin-bottom: 30px;
                  margin-top: 20px;
                "
                v-if="isClssfiy"
              >
                <!-- <div class="classify">
                  <div class="xiangguan">相关分类</div>
                  <div class="classifyname">
                    <span
                      class="text"
                      v-for="item in shopClassifyList"
                      :key="item.classifyId"
                      :class="flIndex == item.classifyId ? 'active' : ''"
                      :name="item.classifyId.toString()"
                      @click="getClassifyProduct(item.classifyId)"
                      >{{ item.classifyName }}</span
                    >
                  </div>
                </div> -->

                <div class="classify">
                  <div class="xiangguan">筛选</div>
                  <div
                    style="margin-right: 30px"
                    @click="tuijianProduct"
                    class="fontB"
                    :class="sxIndex == '4' ? 'active' : ''"
                  >
                    推荐
                  </div>
                  <div
                    style=""
                    @click="shangxinProduct"
                    class="fontB"
                    :class="sxIndex == '5' ? 'active' : ''"
                  >
                    上新
                  </div>
                </div>
                <!-- <HR style="FILTER: alpha(opacity=100,finishopacity=0,style=2)" width="100%" color=#CCC SIZE=10></HR> -->
                <div class="classify">
                  <div class="xiangguan">排序</div>
                  <div
                    class="default fontB"
                    :class="index == '1' ? 'active' : ''"
                    @click="defaultSort()"
                  >
                    默认
                  </div>
                  <div
                    class="prices fontB"
                    style="
                      display: flex !important;
                      justify-content: left !important;
                    "
                    :class="index == '2' ? 'active' : ''"
                    @click="priceSort()"
                  >
                    <span>价格</span>
                    <div class="arr">
                      <div class="up" :class="type == 1 ? 'low' : ''"></div>
                      <div class="down" :class="type == 2 ? 'high' : ''"></div>
                    </div>
                  </div>
                  <div
                    class="sales fontB"
                    :class="index == '3' ? 'active' : ''"
                    @click="salesSort()"
                  >
                    销量
                    <img
                      v-show="index !== '3'"
                      src="../../../static/image/reduce@2x.png"
                      alt=""
                    />
                    <img
                      v-show="index == '3' && volume == 1"
                      src="../../../static/image/reduce2@2x.png"
                      alt=""
                    />
                    <img
                      v-show="index == '3' && volume == 2"
                      src="../../../static/image/reduce1@2x.png"
                      alt=""
                    />
                  </div>
                  <div class="priceBox">
                    <div class="pri fontB">价格</div>
                    <div class="min">
                      ¥<input type="number" v-model="minMoney" />
                    </div>
                    <div style="margin: 0 10px">-</div>
                    <div class="max">
                      ¥<input type="number" v-model="maxMoney" />
                    </div>
                    <div class="btn" @click="priceSearch">确定</div>
                    <div class="clear" @click="clearMoney">清空</div>
                  </div>
                </div>
              </div>
              <div>
                <div
                  v-if="noProduct == false"
                  style="background: #ffffff; padding-bottom: 20px"
                >
                  <!-- <h3>{{classifyTitle}}</h3> -->
                  <ProductList :productList="productList"></ProductList>
                  <div style="">
                    <el-pagination
                      v-if="productList.length > 0 || storeList.length > 0"
                      :current-page="page"
                      :page-size="pageSize"
                      @current-change="handleCurrentChange"
                      background
                      layout="prev, pager, next"
                      :total="total"
                    >
                    </el-pagination>
                  </div>
                </div>
                <div class="noproduct" v-else>
                  <img src="../../../static/image/nothing@2x.png" alt="" />
                  <p class="fs20 font-color-999">该分类没有商品～</p>
                </div>
              </div>
              <!-- <el-pagination v-if="productList.length>0" :current-page="page" :page-size="9999" @current-change="handleCurrentChange" background layout='prev, pager, next' :total='total'>
          </el-pagination> -->
            </div>
          </div>
          <div v-else-if="isContact">
            <contact></contact>
          </div>
          <div v-else-if="isDossier">
            <dossier></dossier>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProductList from "../../components/base/productList";
import api from "../../api";
import { listSearchMixin } from "../../config/mixin";
import CereClassification from "@/components/canvasShow/cereshop/pc/classification";
import { mapGetters, mapMutations } from "vuex";
// import CanvasPage from "../../components/canvasShow/canvasShowPage";
import shopHome from "../../components/canvasShow/shopHome";
import dossier from "../../components/canvasShow/dossier";
import contact from "../../components/canvasShow/contact";
import { Base64 } from "js-base64";
import VueQr from "vue-qr";
export default {
  mixins: [listSearchMixin],
  components: {
    ProductList,
    shopHome,
    dossier,
    contact,
    CereClassification,
    VueQr,
  },
  props: {
    componentContent: {
      type: Object,
    },
    // shopId:{
    //   type:Number||String,
    // }
  },

  data() {
    return {
      shopId: "",
      banner: "",
      activeName: this.$route.query.classify || "all",
      index: "1",
      sxIndex: "",
      flIndex: "",
      classifyTitle: "",
      shopClassifyList: this.$route.query.shopClassifyList || [],
      productList: [],
      storeList: [],
      shopName: null,
      shopLogo: null,
      total: 0,
      type: "",
      volume: "",
      page: 1,
      pageSize: 20,
      ifNew: "",
      noProduct: false,
      isIndex: true,
      isDossier: false,
      isContact: false,
      isShopClassifyList: false,
      item: [],
      classfiyItem: [],
      maxMoney: "",
      minMoney: "",
      searchFrom: {
        search: this.$route.query.search || "",
      },
      adressForm: {
        shopAdress: "",
      },

      chargePersonPhone: "400-082-3633",
      status: "",
      ifNew: "",
      loading: false,
      network: false,
      keyword: "",
      showShopInfo: false,
      showShopWechat: false,
      showClassify: false,
      isClssfiy: false,
      paramClassifyId: "",
      // classifyIdIndex:this.$route.query.classifyId || "",
      classifyId: this.$route.query.classifyId || "",
      activeName: this.$route.query.activeName || "",
      formData: {},
      qrcode: "",
      logoSrc: "",
      appSrc: "",
      shopCode: false,
      showMenu: false,
      showMenu2: false,
      menuChildren: {},
      subMenu: false,
      flagItem: "",
      breadList: [],
    };
  },
  computed: {
    ...mapGetters(["collectData", "classify", "componentContent"]),
    hotClassify() {
      let arr = [];
      this.classify.map((classfiyItem) => {
        classfiyItem.childs.map((obj) => {
          obj.rootName = classfiyItem.categoryName;
        });
        arr = arr.concat(classfiyItem.childs);
      });
      let _arr = [];
      for (let i = 0; i < 4; i++) {
        _arr.push(arr[Math.floor(Math.random() * arr.length)]);
      }
      return _arr;
    },
  },

  mounted() {
    // var shopData = this.$route.query.shopId

    this.shopId = parseInt(this.$route.query.shopId);
    this.getShopIndex();
    this.getShopClassify();
    this.getShopBanner();
    this.status = "";
    this.getShopProducts();
    this.getShopInfo();
    this.getClassifyInfo();
    this.getTopClassify();
    this.searchFrom.search = this.$route.query.search;
    //  console.log(this.searchFrom.search)
    if (this.searchFrom.search) {
      this.getInfoProduct();
    }

    if (this.classifyId) {
      // this.getbread(this.classifyId)
      this.getClassifyProduct(this.classifyId);
    }
    if (this.$route.query.activeName) {
      this.ProducthandleClick(this.$route.query.activeName);
    } else {
      this.activeName = "index";
    }
  },
  methods: {
    gotoIndex() {
      this.$router.push({ path: "/" });
    },
    isActive(name) {
      let curName = "";
      if (this.$route.query.classifyData) {
        curName = JSON.parse(this.$route.query.classifyData).categoryName;
      }
      if (curName === name && this.$route.name === "category") {
        return true;
      }
      return false;
    },
    getChildren(item) {
      this.showMenu2 = true;
      // this.subMenu = true;
      this.menuChildren = item;

      // console.log(this.menuChildren);
    },
    clianChildren(item) {
      this.showMenu2 = false;
      this.flagItem = item.classifyId;
      // this.subMenu = false;
      // this.menuChildren = {};
    },

    //获取顶部分类
    getTopClassify() {
      let self = this;
      let params = {
        url: api.getClassify + ``,
        method: "GET",
        data: {},
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.classfiyItem = res.data;
          // self.activeName = res.data[0].classifyId.toString()
          // self.classifyTitle = res.data[0].classifyName
          // self.getShopProducts()
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    getClassifyInfo() {
      let self = this;
      let _url = api.getClassify + ``;
      // if (self.activeName !== "all") {
      //   _url += `&classifyId=${self.activeName}`;
      // }
      let params = {
        url: _url,
        method: "GET",
        data: {},
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          self.categoryName = res.data.categoryName;
          // self.total = res.data.page.total;
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    getShopInfo() {
      let self = this;
      let _url =
        api.getShopIndex +
        `?shopId=${this.shopId}&page=${self.page}&pageSize=20`;
      // if (self.activeName !== "all") {
      //   _url += `&classifyId=${self.activeName}`;
      // }
      let params = {
        url: _url,
        method: "GET",
        data: {},
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          // self.productList = res.data.page.list;
          // self.total = res.data.page.total;
          if (res.data.page.list.length < 1) {
            self.noProduct = true;
          } else {
            self.noProduct = false;
          }
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    getAllProduct() {
      if (this.searchFrom.search) {
        this.setSearchObj({
          search: this.searchFrom.search,
        });
        if (this.$route.name !== "search") {
          this.$router.push({
            path: "/search",
            query: {
              search: this.searchFrom.search,
            },
          });
        }
        // let self = this;
        // self.loading = true;
        // let params = {
        //   url:
        //     api.getSearchProducts +
        //     `?search=${this.searchFrom.search}&type=${self.type}&maxMoney=${self.maxMoney}&minMoney=${self.minMoney}&volume=${self.volume}&page=${self.page}&pageSize=12`,
        //   method: "GET",
        //   data: {},
        // };
        // self.sendReq(params, (res) => {
        //   if (res.code === "200") {
        //     self.productList = res.data.list;
        //     self.total = res.data.total;
        //     // self.loading = false;
        //     // self.network = false;
        //     if (res.data.list.length < 1) {
        //       self.noProduct = true;
        //     } else {
        //       self.noProduct = false;
        //     }
        //   } else {
        //     self.$message({
        //       message: res.message,
        //       type: "warning",
        //     });
        //     self.network = true;
        //   }
        // });
      } else {
        this.$message({
          message: "请输入搜索内容",
          type: "warning",
        });
      }
    },
    getInfoProduct() {
      if (this.searchFrom.search) {
        this.isIndex = false;
        this.isContact = false;
        this.isDossier = false;
        this.isClssfiy = true;
        this.isShopClassifyList = true;
        let self = this;
        localStorage.setItem("curentPage", self.page);
        if (localStorage.getItem("curentPage")) {
          self.page = localStorage.getItem("curentPage");
        } else {
          self.page = 1;
        }
        let _url =
          api.getShopProducts +
          `?shopId=${this.shopId}&search=${this.searchFrom.search}&page=${self.page}&pageSize=20`;
        // if (self.activeName !== "all") {
        //   _url += `&classifyId=${self.activeName}`;
        // }
        let params = {
          url: _url,
          method: "GET",
          data: {},
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            self.productList = res.data.page.list;
            self.total = res.data.page.total;
            if (res.data.page.list.length < 1) {
              self.noProduct = true;
            } else {
              self.noProduct = false;
            }
          } else {
            self.$message({
              message: res.message,
              type: "warning",
            });
          }
        });
      } else {
        this.$message({
          message: "请输入搜索内容",
          type: "warning",
        });
      }
    },
    getClassifyProduct(classifyId) {
      this.getbread(classifyId);
      this.isIndex = false;
      this.isContact = false;
      this.isDossier = false;
      this.isClssfiy = true;
      this.isShopClassifyList = true;
      this.flIndex = classifyId;
      this.paramClassifyId = classifyId;
      this.sxIndex = "";
      let self = this;
      self.page = 1;
      let _url =
        api.getShopProducts +
        `?shopId=${this.shopId}&classifyId=${self.paramClassifyId}&page=${self.page}&pageSize=${self.pageSize}&ifNew=${self.ifNew}&maxMoney=${self.maxMoney}&minMoney=${self.minMoney}&volume=${self.volume}&type=${self.type}&status=${self.status}`;
      // if (self.activeName !== "all") {
      //   _url += `&classifyId=${self.activeName}`;
      // }
      let params = {
        url: _url,
        method: "GET",
        data: {},
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          self.productList = res.data.page.list;
          self.total = res.data.page.total;
          if (res.data.page.list.length < 1) {
            self.noProduct = true;
          } else {
            self.noProduct = false;
          }
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    //价格搜索
    priceSearch() {
      this.page = 1;
      this.search = "";
      this.getShopProducts();
    },
    // 清空价格搜索
    clearMoney() {
      this.minMoney = "";
      this.maxMoney = "";
      this.flIndex = "";
      this.sxIndex = "";
      this.index = "1";
      this.status = "";
      this.ifNew = "";
      this.paramClassifyId = "";
      this.classifyId = "";
      let self = this;
      let _url =
        api.getShopProducts +
        `?shopId=${this.shopId}&page=${self.page}&pageSize=20`;
      // if (self.activeName !== "all") {
      //   _url += `&classifyId=${self.activeName}`;
      // }
      let params = {
        url: _url,
        method: "GET",
        data: {},
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          self.productList = res.data.page.list;
          self.total = res.data.page.total;
          if (res.data.page.list.length < 1) {
            self.noProduct = true;
          } else {
            self.noProduct = false;
          }
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    //推荐商品
    tuijianProduct() {
      this.page = 1;
      this.sxIndex = "4";
      this.status = 1;
      this.ifNew = "";
      this.getShopProducts();
    },
    // 上新商品
    shangxinProduct() {
      this.page = 1;
      this.sxIndex = "5";
      this.status = "";
      this.ifNew = 2;
      this.getShopProducts();
    },
    // 获取搜索商品数据
    getSearchProducts() {
      let self = this;
      self.loading = true;
      let params = {
        url:
          api.getSearchProducts +
          `?search=${self.keyword}&shopId=${self.shopId}&classfiyId=${self.classfiyId}${self.keyword}&type=${self.type}&maxMoney=${self.maxMoney}&minMoney=${self.minMoney}&volume=${self.volume}&page=${self.page}&pageSize=12`,
        method: "GET",
        data: {},
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          self.productList = res.data.page.list;
          self.total = res.data.page.total;
          self.loading = false;
          self.network = false;
          if (res.data.list.length < 1) {
            self.noProduct = true;
          } else {
            self.noProduct = false;
          }
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
          self.network = true;
        }
      });
    },
    ...mapMutations({
      setCollectData: "SET_COLLECTDATA",
      setSearchObj: "SET_SEARCHOBJ",
    }),
    collect() {
      if (this.collectData.ifCollect === 0) {
        let params = {
          url: api.collect,
          method: "POST",
          data: {
            shopId: this.collectData.shopId,
          },
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            let data = {
              shopName: this.collectData.shopName,
              shopAdress: this.collectData.shopAdress,
              collectId: this.collectData.collectId,
              ifCollect: 1,
              classifyNumber: res.data.classifyNumber,
              number: res.data.number,
              shopLogo: res.data.shopLogo,
            };
            this.setCollectData(data);
            this.$message.success("关注成功");
          }
        });
      } else {
        let params = {
          url: api.unfavorite,
          method: "PUT",
          data: {
            ids: [this.collectData.collectId],
          },
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            let data = {
              shopName: this.collectData.shopName,
              shopAdress: this.collectData.shopAdress,
              collectId: this.collectData.collectId,
              ifCollect: 0,
              classifyNumber: res.data.classifyNumber,
              number: res.data.number,
              shopLogo: res.data.shopLogo,
            };
            this.setCollectData(data);
            this.$message.success("取消成功");
          }
        });
      }
    },
    // 获取店铺首页
    getShopIndex() {
      let params = {
        url: api.getShopIndex + `?shopId=${this.shopId}`,
        method: "GET",
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          this.formData = res.data;
          let data = {
            ifCollect: res.data.ifCollect,
            collectId: res.data.collectId,
            shopAdress: res.data.shopAdress,
            shopName: res.data.shopName,
            shopId: res.data.shopId,
            classifyNumber: res.data.classifyNumber,
            number: res.data.number,
            shopLogo: res.data.shopLogo,
          };
          this.adressForm.shopAdress = res.data.shopAdress;
          this.shopName = res.data.shopName;
          this.shopLogo = res.data.shopLogo;
          this.setCollectData(data);
          this.qrcode = res.data.shopQrCode;
          Base64.decode(this.qrcode);
          console.log(this.qrcode);
          console.log(Base64.decode(this.qrcode));
          // this.appSrc = Base64.decode(this.qrcode);
          this.appSrc = this.qrcode;
          if (res.data.shopLogo) {
            this.logoSrc = res.data.shopLogo;
          } else {
            this.logoSrc =
              "https://static.xhngyl.com/xhngyl-platform-gy/dev/logo/2021-11-12/1d635fcd30cc44e2832f6e1a91d689d2-logo.png";
          }
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 获取店铺分类
    async getShopClassify() {
      let self = this;
      let params = {
        url: api.getShopClassify + `?shopId=${self.shopId}`,
        method: "GET",
        data: {},
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.shopClassifyList = res.data.filter(
            (item) => JSON.stringify(item) !== "{}"
          );
          // self.activeName = res.data[0].classifyId.toString()
          // self.classifyTitle = res.data[0].classifyName
          // self.getShopProducts()
          console.log(self.shopClassifyList);
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    getbread(id) {
      console.log(this.shopClassifyList);
      this.breadList = [];
      // let params = {
      //   url: api.getShopClassify + `?shopId=${this.shopId}`,
      //   method: "GET",
      //   data: {},
      // };
      // this.sendReq(params, (res) => {
      //   if (res.code === "200") {
      //     console.log(res.data);
      //     this.shopClassifyList = res.data
      //   }
      // });

      for (let i = 0; i < this.shopClassifyList.length; i++) {
        let item1 = this.shopClassifyList[i];
        if (item1 && id == item1.classifyId) {
          this.breadList.push(item1);
        } else {
          for (let j = 0; j < item1.childs.length; j++) {
            let item2 = item1.childs[j];
            if (id == item2.classifyId) {
              this.breadList.push(item1);
              this.breadList.push(item2);
            } else {
              for (let k = 0; k < item2.childs.length; k++) {
                let item3 = item2.childs[k];
                if (id == item3.classifyId) {
                  this.breadList.push(item1);
                  this.breadList.push(item2);
                  this.breadList.push(item3);
                }
              }
            }
          }
        }
      }
      console.log(this.breadList);
    },

    // 获取店铺banner
    getShopBanner() {
      let self = this;
      let params = {
        url: api.getShopBanner + `?shopId=${self.shopId}`,
        method: "GET",
        data: {},
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          if (res.data.length > 0) {
            self.banner = res.data[0].bannerImage;
          }
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // 获取店铺商品
    getShopProducts() {
      let self = this;
      if (sessionStorage.getItem("curentPage5")) {
        self.page = sessionStorage.getItem("curentPage5");
      } else {
        self.page = 1;
      }
      let _url =
        api.getShopProducts +
        `?shopId=${self.shopId}&ifNew=${self.ifNew}&maxMoney=${self.maxMoney}&minMoney=${self.minMoney}&classifyId=${self.paramClassifyId}&status=${self.status}&page=${self.page}&pageSize=${self.pageSize}&type=${self.type}&volume=${self.volume}`;
      // if (self.activeName !== "all") {
      //   _url += `&classifyId=${self.activeName}`;
      // }
      let params = {
        url: _url,
        method: "GET",
        data: {},
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.productList = res.data.page.list;
          self.shopName = res.data.shopName;
          self.total = res.data.page.total;
          self.shopLogo = res.data.shopLogo;
          if (res.data.page.list.length < 1) {
            self.noProduct = true;
          } else {
            self.noProduct = false;
          }
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    ProducthandleClick(activityName) {
      if (activityName === "index") {
        this.isIndex = true;
        this.isShopClassifyList = false;
        this.isContact = false;
        this.isDossier = false;
      } else if (activityName === "shopClassifyList") {
        this.isIndex = false;
        this.isContact = false;
        this.isDossier = false;
        this.isShopClassifyList = true;
        this.isClssfiy = true;
      } else if (activityName === "contact") {
        this.isIndex = false;
        this.isShopClassifyList = false;
        this.isContact = true;
        this.isDossier = false;
      } else if (activityName === "dossier") {
        this.isIndex = false;
        this.isShopClassifyList = false;
        this.isDossier = true;
        this.isContact = false;
      }
    },
    // 频道
    handleClick(event) {
      //接受详情页导航栏的参数
      // this.classifyTitle = event.label;

      if (sessionStorage.getItem("curentPage4")) {
        sessionStorage.removeItem("curentPage4");
      }
      if (sessionStorage.getItem("curentPage5")) {
        sessionStorage.removeItem("curentPage5");
      }
      if (event.name === "index") {
        this.isIndex = true;
        this.isShopClassifyList = false;
        this.isContact = false;
        this.isDossier = false;
      } else if (event.name === "shopClassifyList") {
        this.isIndex = false;
        this.isContact = false;
        this.isDossier = false;
        this.isShopClassifyList = true;
        this.isClssfiy = true;
      } else if (event.name === "contact") {
        this.isIndex = false;
        this.isShopClassifyList = false;
        this.isContact = true;
        this.isDossier = false;
      } else if (event.name === "dossier") {
        this.isIndex = false;
        this.isShopClassifyList = false;
        this.isDossier = true;
        this.isContact = false;
      }
    },
    // 分页器跳转
    handleCurrentChange(val) {
      this.page = val;
      localStorage.setItem("curentPage5", this.page);
      this.getShopProducts();
    },
    // 默认排序
    defaultSort() {
      this.type = "";
      this.volume = "";
      this.index = "1";
      this.page = 1;
      this.getShopProducts();
    },
    // 价格排序
    priceSort() {
      if (this.type !== 1) {
        this.type = 1;
      } else {
        this.type = 2;
      }
      this.page = 1;
      this.volume = "";
      this.index = "2";
      this.getShopProducts();
    },
    // 销量排序
    salesSort() {
      if (this.volume !== 1) {
        this.volume = 1;
      } else {
        this.volume = 2;
      }
      this.page = 1;
      this.type = "";
      this.index = "3";
      this.getShopProducts();
    },
  },
};
</script>
<style lang="scss">
*[data-v-3fb1a7fa],
*[data-v-3fb1a7fa]:before,
*[data-v-3fb1a7fa]:after {
  cursor: pointer;
}
.icon-The-editor-02 {
  transition: all 0.3s;
  transform: rotate(0);
}
.priceBox {
  display: flex;
  // margin-left: 20px;
  .min,
  .max {
    display: flex;
    width: 100px;
    height: 30px;
    padding: 0 5px;
    border: 1px solid #ccc;
    box-sizing: border-box;
    border-radius: 2px;
    line-height: 30px;
    input {
      width: 70px;
      flex: 1;
      outline: none;
      border: none;
    }
  }
  .pri {
    margin-right: 10px;
  }
  .btn {
    width: 60px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #ccc;
    box-sizing: border-box;
    cursor: pointer;
    margin: 0 20px;
    text-align: center;
  }
  .clear {
    cursor: pointer;
    color: #999999;
    height: 30px;
    line-height: 30px;
  }
}
.main {
  background: #f5f5f5;
}
</style>
<style lang = "scss" scoped>
.bread {
  &:hover {
    color: #ff7b0b;
    cursor: pointer;
  }
}
.ShopMenu {
  position: absolute;
  top: 43px;
  left: 0;
  z-index: 999999;
}
.selectMenu {
  transform: rotate(180deg);
}
.selectMenuSub {
  color: #ff7b0b;
}
.el-icon-caret-bottom {
  transition: all linear 0.3s;
}
.menuall {
  display: flex;
  justify-content: left;

  // height: 300px;
  background-color: #fff;
  margin-top: 4px;
  padding: 5px 0;

  border-radius: 4px;
  box-shadow: 0px 7px 11px 4px rgba(231, 234, 235, 0.5);
}
.menuItem {
  width: 150px;
  margin: 5px 0;
  text-align: left;
  padding-left: 30px;
  font-size: 16px;
  color: #000000;

  .selectMenu2 {
    transition: all linear 0.2s;
  }
  &:hover {
    color: #f77b0b;
    .selectMenu2 {
      transform: rotate(180deg);
      transition: all linear 0.2s;
    }
  }
}
.hoverBox {
  width: auto;
  // padding: 6px 25px;
  height: 100%;
  // left: 100%;
  // top: 0;
  z-index: 3;
  // display: none;
  background-color: #fff;
  color: #333;
  // box-shadow: -3px 9px 15px 0px rgba(0, 0, 0, 0.5);
  // border: 2px solid $mainColor;

  .dl {
    margin-bottom: 5px;
    display: flex;

    .dt {
      width: 100px;
      margin-left: 30px;
      height: 50px;
      display: flex;
      // padding-top: 5px;
      // align-items: center;
      align-items: flex-start;
      font-size: 16px;
      font-weight: bold;
      color: #000000;
    }
    .dt:hover {
      color: #ff7b0b;
    }
    .dd {
      display: flex;
      width: 800px;
      margin-left: 10px;
      flex-wrap: wrap;
      border-bottom: 1px dotted #e5e5e5;

      // padding-top: 23px;
      a {
        display: flex;
        align-items: flex-start;
        height: 41px;
        font-size: 14px;
        // align-items: center;

        margin-right: 40px;
        &:hover {
          color: #ff7b0b;
        }
      }
    }
    &:nth-last-child(1) {
      .dd {
        border-bottom: 0px dotted #e5e5e5;
      }
    }
  }
}
.store {
  width: 100%;
  /* padding-top: 30px; */
  padding-bottom: 30px;
  .banxin {
    margin: 0 auto;
    /* background: #fff; */
    .shop {
      /* height: 111px; */
      /* background: #fff; */
      display: flex;
      /* margin-top: 20px; */
      width: 100%;
      height: 133px;
      /* background: url("../../assets/images/shopHeaderBj.png") no-repeat; */
      align-items: center;
      /* padding-left: 50px; */
      .shop1 {
        width: 50%;
        margin-left: 80px;
        display: flex;
        justify-content: space-between;
      }
      .shopLogo {
        width: 76px;
        height: 76px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        margin-left: 85px;
        img {
          width: 100%;
        }
        margin-right: 17px;
      }
      .shopInfo-box {
        height: 76px;
        display: flex;

        flex-direction: column;
        justify-content: space-around;
        .shopName {
          cursor: pointer;
          font-size: 30px;
          font-weight: bold;
          color: #333333;
        }
        span {
          font-size: 14px;
          color: #606266;
          display: flex;
          align-items: center;
          img {
            width: 16px;
            margin-right: 4px;
          }
          img:first-child {
            margin-left: 12px;
          }
        }
      }
      .shopInfo {
        width: 200px;
        padding-left: 70px;
        .favoritesBox {
          display: flex;
          align-items: center;
          img {
            margin-right: 5px;
          }
        }
      }
      .shopName {
        font-size: 30px;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .el-tab-box {
      height: 45px;
      background: url("../../assets/images/tabsBg.png");
    }
    >>> .el-tabs {
      height: 45px;
      /* background: url("../../assets/images/tabsBg.png"); */
      background-size: 100% auto;
      color: #fff;
      padding-left: 20px;
      line-height: 45px;
      /* margin-bottom: 15px; */
      .el-tabs__item.is-active {
        color: #f5deae;
        background: #534c3e;
        border-bottom: none;
      }
      .el-tabs__active-bar {
        background-color: #534c3e;
      }
      .el-tabs__item {
        height: 43px;
        margin-top: -2px !important;
        font-size: 16px;
        color: #ffffff;
      }
      .el-tabs__item:hover {
        color: #f5deae;
        background: #534c3e;
      }
      .el-tabs__nav-wrap::after {
        display: none;
      }
      .el-tabs__nav-wrap {
        overflow: visible;
      }
      .el-tabs__header {
        border: none !important;
      }
      .el-tabs__nav-scroll {
        height: 45px;
        overflow: visible;
      }
    }
    >>> #tab-contact {
      padding-right: 20px !important;
    }
    >>> #tab-index {
      padding-left: 20px !important;
    }
    .banner {
      width: 100%;
      height: 356px;
      margin-bottom: 25px;
    }
    .content {
      width: 100%;
      margin-top: 20px;
      /* padding: 0 45px 30px; */
      box-sizing: border-box;
      .sort {
        width: 100%;
        height: 71px;
        background-color: #fff;
        line-height: 27px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f1f1f1;
        color: #666666;
        margin-bottom: 20px;
        /* padding: 0 85px; */
        padding-left: 20px;
        .default {
          margin-left: 40px;
          cursor: pointer;
        }
        .sales {
          cursor: pointer;
          img {
            width: 9px;
            height: 16px;
            vertical-align: middle;
          }
        }
      }
      .prices {
        display: flex !important;
        justify-content: left !important;
        width: 70px !important;
        span {
          display: inline-block !important;
          width: 40px !important;
        }
        /* margin: 0 20px; */
        cursor: pointer;
        .arr {
          vertical-align: middle;
          width: 12px;
          margin-left: 5px;
          margin-top: 2px;
          .up {
            width: 0;
            height: 0;
            border: 6px solid transparent;
            border-bottom-color: #999999;
          }
          .down {
            width: 0;
            height: 0;
            border: 6px solid transparent;
            border-top-color: #999999;
            margin-top: 3px;
          }
        }
      }
      .active {
        color: #ff7800;
        .arr {
          .high {
            border-top-color: #ff7800;
          }
          .low {
            border-bottom-color: #ff7800;
          }
        }
      }
    }
    h3 {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 80px;
    }
    .noproduct {
      width: 100%;
      text-align: center;
      padding: 200px 0;
    }
  }
  >>> .el-pagination {
    text-align: right;
    .el-pager {
      li:not(.disabled):hover {
        color: #ff7800;
      }
      li:not(.disabled).active {
        background-color: #ff7800;
      }
      li:not(.disabled).active:hover {
        color: #f4f4f5;
      }
    }
  }
  .el-input {
    border-color: #ff7800 !important;
  }
  .tabs {
    >>> .el-tabs__item {
      width: 150px !important;
      text-align: center;
    }
  }
  .guanzhu {
    z-index: 66;
    width: 64px;
    height: 28px;
    border-radius: 28px;
    text-align: center;
    line-height: 28px;
    color: rgba(255, 71, 71, 1);
    border: 1px solid rgba(255, 71, 71, 1);
    margin-left: 30px;
    margin-top: 9px;
    &:hover {
      cursor: pointer;
      background-color: rgba(255, 71, 71, 1);
      color: #fff;
    }
    .clearfix {
      display: flex;
      .a {
        margin-left: 10px;
        font-size: 20px;
      }
      .b {
        margin-left: 20px;
      }
      .c {
        margin-left: 20px;
        margin-top: 5px;
      }
    }
    .qiyerenzheng {
      display: flex;
      .d {
        margin-left: 20px;
      }
      .e {
      }
    }
  }
  .word {
    position: absolute;
    padding: 0 5px;
    width: 45px;
    height: 21px;
    display: block;
    text-align: center;
    overflow-wrap: break-word;
    color: rgba(255, 71, 71, 1);
    font-size: 16px;
    line-height: 21px;
    text-align: center;
    border-radius: 50%;
  }
  .block11 {
    /* z-index: auto; */
    width: 100%;
    text-align: center;
    height: 71px;
    margin-top: 18px;
    margin-right: 30px;
    display: flex;
    justify-content: right;
  }
  .img1 {
    /* z-index: 406; */
    width: 50px;
    height: 50px;
    align-self: flex-start;
    margin-bottom: 5px;
  }
  .word63 {
    /* z-index: 403; */
    width: 64px;
    height: 24px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 16px;
    font-family: MicrosoftYaHei;
    white-space: nowrap;
    line-height: 21px;
    text-align: left;
    margin: 75px 0 0 629px;
  }
  .info34 {
    /* z-index: 404; */
    /* width: 104px; */
    /* height: 21px; */
    /* margin-left: -30px; */
    display: block;
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 16px;
    font-family: MicrosoftYaHei;
    white-space: nowrap;
    line-height: 21px;
    text-align: left;
    align-self: flex-end;
  }
  .block12 {
    z-index: 650;
    width: 96px;
    height: 74px;
    /* padding-left: 100px; */
    margin: 20px 0 0 20px;
    position: relative;
    .erweimamokuai {
      position: absolute;
      left: -200px;
      top: 80px;
      z-index: 199;
    }
  }

  .bd26 {
    width: 49px;
    height: 50px;
    /* background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng4bc66d625ff556f33e6c19c2d78e4160faa46d19ac5a8d34c3d9a16c103badf3)
      100% no-repeat; */
    align-self: center;
  }
  .shopHeard {
    display: flex;
  }
  .info35 {
    width: 96px;
    height: 21px;
    display: block;
    margin-left: -10px;
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 16px;
    font-family: MicrosoftYaHei;
    white-space: nowrap;
    line-height: 21px;
    margin-top: 3px;
  }

  .classify {
    margin-right: 20px;
    background-color: #fff;
    display: flex;
    padding: 20px;
    font-size: 16px;
    &:nth-child(1) {
      border-bottom: 1px dotted #e5e5e5;
    }
    &:nth-child(2) {
      border-bottom: 1px dotted #e5e5e5;
    }
    .fontB {
      font-size: 16px;
      line-height: 30px;
      /* font-weight: bold; */
      margin-right: 20px;
      color: #2c2b2b;
      cursor: pointer;
    }
    width: 100%;
    .xiangguan {
      /* height:50px;
    line-height: 50px; */
      margin-left: 20px;
      text-align: left;
      width: 100px;
      color: #666666;
    }
    .text {
      margin-right: 30px;
      cursor: pointer;
      color: #2c2b2b;
      /* font-weight: bold; */

      .classifyname {
        width: 60%;
      }
    }
  }
  .renzheng {
    width: 80px;
    height: 27px;
    margin-top: 10px;
    margin-right: 20px;
  }
  .information {
    /* height: 35px; */
    display: flex;
    /* margin-top: 10px; */
    align-items: center;
    position: relative;

    .qiye {
      width: 18px;
      /* height: 24px; */

      /* margin-left: 20px; */
      margin-top: 10px;
    }
    .dingwei {
      height: 17px;

      margin-left: 20px;
      /* margin-top: 7px; */
    }
    .gyl {
      width: 30px;
      height: 67px;
      background: #fff;
    }
    .qiyeAge {
      margin-left: 10px;
      margin-top: 10px;
      width: 50px;
      font-size: 16px !important;
    }
    .shangchengLogo {
      width: 298px;
      height: 67px;
    }
    .dizhi {
      font-size: 16px !important;
      margin-left: 10px;
      width: auto;
      margin-top: 9px;
      height: 30px;
    }
    .chanpin {
      font-size: 16px;
      margin-left: 10px;
      margin-top: 9px;
      width: 200px;
      height: 30px;
    }

    .infomokuai {
      position: absolute;
      left: 0;
      top: 30px;
      padding-top: -30px;
      z-index: 88;
    }
  }
  .toutou {
    display: flex;
    justify-content: left;
    width: 100%;
    height: 152px;
    padding: 20px 0;
    /* padding-top: 20px; */
    /* padding-left: 55px; */
    .logo {
      width: 300px;
      margin-top: 24px;
      /* padding-left: 30px; */
    }

    .menu {
      /* padding: 29px 0 0 0; */
      display: flex;
      align-items: center;
      padding-left: 30px;

      .menu-flag {
        height: 46px;
        padding: 10px 20px;
        border: 1px solid #e5e5e5;
        border-radius: 2px;
        /* background: linear-gradient(180deg, #ff871b 0%, #ff5523 100%); */
        line-height: 46px;
        /* border-radius: 8px 8px 0px 0px; */
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 20px;
        cursor: default;
        position: relative;
        & > div {
          display: flex;
          align-items: center;
        }
        .anticon-menu {
          font-size: 24px;
          margin-right: 27px;
        }
        .icon-The-editor-02 {
          transition: all 0.3s;
          transform: rotate(0);
        }
        .turnDown {
          transform: rotate(90deg);
          transition: all 0.3s;
        }
        .turnDown2 {
          transform: rotate(0);
          transition: all 0.3s;
        }
        .classify-outer {
          position: absolute;
          left: 0px;
          top: 54px;
          width: 315px;
          padding: 0;
          /* height: 0; */
          /* overflow: hidden; */
          /* transition: all 0.3s; */
          z-index: 2;
        }
        .showClassify {
          /* height: 717px; */
        }
      }
      & > ul {
        height: 55px !important;
        line-height: 55px;
      }
      li {
        display: inline-block;
        line-height: 28px;
        a {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          display: block;
          cursor: pointer;
          padding: 0 63px 0 0;
          &:hover {
            color: $mainColor;
          }
        }
        .active {
          color: $mainColor;
        }
      }
      li:first-child {
        padding-left: 46px;
      }
    }
    .showClassify {
      height: 700px;
      border: 1px solid #e5e5e5;
    }
    .shopfl {
      text-align: center;
      /* margin-top: 10px;
      margin-left: 30px; */
      font-size: 20px;
      padding: 0 60px;
    }
    >>> .searchright {
      /* width: 633px; */
      height: 61px;
      display: flex;
      border-radius: 8px;
      display: flex;
      margin-top: 26px;
      justify-content: right;
      /* border: 1px solid #f77b0b; */
      padding-left: 150px;
      .shuru {
        height: 61px;
        width: 700px;
      }
      .bendain {
        width: 112px;
        height: 65px;
        margin-left: 7px;
      }
      .quanzhan {
        z-index: 500;
      }
      .bdBtn {
        background: #333333;
        height: 61px;
        width: 112px;
        font-size: 20px;
        border-radius: 8px !important;
      }
    }
    .souzj {
      margin-left: 20px;
    }
    .info {
      border-radius: 8px;
    }

    .menu-flag {
      text-align: center;
    }
    .serachBtn {
      float: right;
    }

    /* >>> .store .block11[data-v-3fb1a7fa] {
      padding-left: 1100px !important;
    } */
  }
  .dingbu {
    width: 100%;
    /* height: 285px; */

    background: #fff;
  }
  >>> .swiper-content {
    margin-top: 16px !important;
    /* margin-left: 10px !important; */
  }
}
>>> #tab-contact {
  padding-right: 20px !important;
}
>>> #tab-index {
  padding-left: 20px !important;
}
>>> .el-input__inner {
  height: 61px;
  font-size: 16px;
  padding: 0 60px 0 52px !important;
  border-radius: 8px;
  border: 1px solid #f77b0b;
}
>>> .el-input--prefix.el-input__icon {
  height: 100%;
  width: 100%;
  margin-left: 10px;
  text-align: center;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  line-height: 40px;
}
>>> .el-input__icon {
  height: 100%;
  width: 25px;
  font-size: 24px;
  margin-left: 10px;
  padding-top: 3px;
  text-align: center;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  line-height: 40px;
}
.qzBtn {
  width: 112px;
  height: 61px;
  border-radius: 8px !important;
  margin-left: -8px;
  font-size: 20px;
  background: linear-gradient(90deg, #ff871b 0%, #ff5523 100%);
  border: 1px solid #f77b0b;
}
</style>
<style scoped>
@media only screen and (max-width: 1080px) {
  .el-tab-box {
    height: 45px;
    background: url("../../assets/images/tabsBg.png") no-repeat 100%/100% !important;
  }
  .shop {
    background: url("../../assets/images/shopHeaderBg1080.png") 100%/100%
      no-repeat;
    height: 133px;
  }
}
@media only screen and (min-width: 1080px) {
  .el-tab-box {
    height: 45px;
    background: url("../../assets/images/tabsBg.png") no-repeat 100%/100% !important;
  }
  .shop {
    background: url("../../assets/images/shopHeaderBg1080.png") 100%/100%
      no-repeat;
    height: 133px;
  }
}
@media only screen and (min-width: 2200px) {
  .el-tab-box {
    height: 45px;
    background: url("../../assets/images/tabsBg2.png") no-repeat 100%/100% !important;
  }
  .shop {
    background: url("../../assets/images/shopHeaderBg2560.png") no-repeat 100%/100%;
    height: 133px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/store/index.vue